import React, { ErrorInfo, ReactNode } from 'react';
import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { SeverityLevel } from '@microsoft/applicationinsights-common';
import { ErrorBoundaryProps, ErrorBoundary } from 'react-error-boundary';

type AppErrorBoundaryProps = { children: ReactNode } & ErrorBoundaryProps;
function AppErrorBoundary({ children, ...ebProps }: AppErrorBoundaryProps) {
  const appInsights = useAppInsightsContext();
  return (
    <ErrorBoundary
      {...ebProps}
      onError={(error: Error, info: ErrorInfo) => {
        appInsights?.trackException({
          error,
          exception: error,
          severityLevel: SeverityLevel.Error,
          properties: info,
        });
      }}
    >
      {children}
    </ErrorBoundary>
  );
}

export default AppErrorBoundary;
